export default __webpack_public_path__ + "static/media/cladding.a4672541.png";